import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-service-hero',
  templateUrl: './service-hero.component.html',
  styleUrls: ['./service-hero.component.css'],
})
export class ServiceHeroComponent {
  @Input() language!: string;
  @Input() data!: any;
  @Input() fileName!: string;
}
